module.exports = __webpack_public_path__ + "media/images/get_start-e1920d3f6e34a210429334d3c5973306.svg";